import { useEffect, useState } from "react";

const navLinks = [
  { href: "#updates", label: "最新更新" },
  { href: "#ranking", label: "追更榜" },
  { href: "#categories", label: "主题分类" },
  { href: "#featured", label: "热门连载" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_oklch(var(--background-200))]"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-[72px] max-w-[1280px] items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2" aria-label="妖精漫画首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-sparkling-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-xl md:text-2xl tracking-wide text-foreground-950">
            妖精漫画
          </span>
        </a>

        <div className="hidden items-center gap-7 md:flex">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <a
            href="#updates"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            立即追更
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-900 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={`ri-${open ? "close" : "menu"}-line text-2xl`}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#updates"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50"
            >
              立即追更
            </a>
          </div>
        </div>
      )}
    </header>
  );
}